// Shared display helpers for the AI Info subcomponents. Compact + dependency-free,
// copied from the ApiInteractions precedent (that file keeps its time helpers
// local rather than sharing) but centralized here since several AI Info sections
// render timestamps.

// Compact relative time ("3m ago", "2h ago", "—" if null/invalid).
export const relativeTime = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  const secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 0) return 'just now';
  if (secs < 60) return secs + 's ago';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return mins + 'm ago';
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return hrs + 'h ago';
  const days = Math.floor(hrs / 24);
  if (days < 30) return days + 'd ago';
  return d.toLocaleDateString();
};
